import React from 'react';
import PropTypes from 'prop-types';
import Select from '@Components/Select';
import HeaderInfoIcon from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoIcon';
import HeaderInfoTooltip from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoTooltip';
import DialogRow from '@Pages/RetroSynthesis/ExportRoute/components/DialogRow';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';

import './ExportFormats.theme.scss';

const ExportFormats = ({ options, tooltipText, onSelectFormat, value }) => {
  return (
    <DialogRow className="export-formats" label="Choose a format:">
      <div className="flex-row-container">
        <Select
          e2eName="export-formats-select"
          options={options}
          fillDropdownIndicator={false}
          value={value}
          customCssClass="export-dialog-select"
          selectOptionHandler={(option) => onSelectFormat(option)}
        />
        <div className="export-formats__tooltip">
          <HeaderInfoIcon tooltipId="export-formats-tooltip" />
          <HeaderInfoTooltip id="export-formats-tooltip" rightAlign>
            <div className="rs-tooltip-big__content tooltip-content">
              <InnerHTML
                html={tooltipText}
                tag="span"
                mode="escape"
                allowedTags={allowedTagsDefault.concat('a')}
                allowedAttributes={['href', 'target']}
              />
            </div>
          </HeaderInfoTooltip>
        </div>
      </div>
    </DialogRow>
  );
};

export default ExportFormats;

ExportFormats.propTypes = {
  onSelectFormat: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.any,
  tooltipText: PropTypes.string,
};
